/* 18+ age gate. See snippets/age-gate.liquid for why this exists and what it replaced.

   The gate is already in the HTML when this runs, and the inline check in doc-head-core.liquid
   has already decided whether it paints at all. This file only handles the answer: storing a
   pass, releasing the page, and holding focus inside the dialog until one of that happens. */
(function ageGate() {
  var KEY = 'sevendays:age-ok';
  var gate = document.getElementById('age-gate');
  if (!gate) return;

  // The inline check in doc-head-core.liquid has already run and, for a visitor who answered
  // before, CSS has hidden the gate. Opening it here anyway would lock the page scroll behind
  // a dialog nobody can see - so take the element out of the document and stop.
  if (document.documentElement.classList.contains('age-verified')) {
    gate.hidden = true;
    return;
  }

  var script = document.currentScript
    || document.querySelector('script[src*="age-gate.js"]');
  var rememberDays = parseInt((script && script.dataset.rememberDays) || '30', 10);
  if (!rememberDays || rememberDays < 1) rememberDays = 30;

  var ask = gate.querySelector('[data-age-gate-ask]');
  var declined = gate.querySelector('[data-age-gate-declined]');
  var yesBtn = gate.querySelector('[data-age-gate-yes]');
  var noBtn = gate.querySelector('[data-age-gate-no]');
  var lastFocus = null;

  // Storage can throw rather than fail quietly - Safari in private mode does exactly that on
  // write - so every access is guarded. A visitor whose storage is blocked gets asked again on
  // the next visit, which is the safe direction for a gate to fail in.
  function remember() {
    var until = Date.now() + rememberDays * 24 * 60 * 60 * 1000;

    try {
      localStorage.setItem(KEY, String(until));
      return;
    } catch (e) {
      // Fall through to the cookie.
    }

    try {
      document.cookie = KEY + '=' + until
        + ';path=/;max-age=' + rememberDays * 24 * 60 * 60
        + ';SameSite=Lax'
        + (location.protocol === 'https:' ? ';Secure' : '');
    } catch (e) {
      // Nothing left to try; the visitor will be asked again next time.
    }
  }

  function lockScroll(locked) {
    document.documentElement.classList.toggle('age-gate-open', locked);
  }

  // Nothing behind the gate should be reachable by keyboard while it is up. Rather than
  // tracking every focusable element on the page, pull focus back whenever it escapes.
  function trapFocus(evt) {
    if (gate.hidden || gate.contains(evt.target)) return;
    evt.stopPropagation();
    var target = declined && !declined.hidden ? declined : yesBtn;
    if (target) target.focus();
  }

  function open() {
    lastFocus = document.activeElement;
    lockScroll(true);
    document.addEventListener('focusin', trapFocus, true);
    if (yesBtn) yesBtn.focus();
  }

  function close() {
    gate.hidden = true;
    lockScroll(false);
    document.removeEventListener('focusin', trapFocus, true);
    document.documentElement.classList.add('age-verified');

    // Hand focus to the content rather than letting it fall back to <body>, where a screen
    // reader would be left at the top of the document with no announcement that the dialog
    // had gone. Only restore the previously focused element if it was a real control outside
    // the gate - on a first load it is <body>, which is the case this exists to avoid.
    var main = document.getElementById('main-content');
    var restorable = lastFocus
      && lastFocus !== document.body
      && document.contains(lastFocus)
      && !gate.contains(lastFocus);

    if (restorable) {
      lastFocus.focus();
    } else if (main) {
      main.setAttribute('tabindex', '-1');
      main.focus();
    }
  }

  function accept() {
    remember();
    close();
  }

  function decline() {
    if (!ask || !declined) return;
    ask.hidden = true;
    declined.hidden = false;
    // The dialog's accessible name still points at the original heading, so move the pointer
    // to the one now on screen and announce the change.
    var heading = declined.querySelector('.age-gate__heading');
    if (heading) {
      if (!heading.id) heading.id = 'age-gate-declined-heading';
      gate.setAttribute('aria-labelledby', heading.id);
      heading.setAttribute('tabindex', '-1');
      heading.focus();
    }
  }

  if (yesBtn) yesBtn.addEventListener('click', accept);
  if (noBtn) noBtn.addEventListener('click', decline);

  // Escape must not dismiss this one. Swallow it so a habitual press does not look like it
  // half-worked, and so it never reaches a theme drawer sitting behind the gate.
  gate.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape') evt.preventDefault();
  });

  open();
}());
